import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";

export function Pagination({
	offset,
	pageSize,
	total,
	onOffsetChange,
	className,
}: {
	offset: number;
	pageSize: number;
	total: number;
	onOffsetChange: (next: number) => void;
	className?: string;
}) {
	const from = total === 0 ? 0 : offset + 1;
	const to = Math.min(offset + pageSize, total);
	const canPrev = offset > 0;
	const canNext = offset + pageSize < total;

	return (
		<div
			className={cn(
				"flex flex-wrap items-center justify-center gap-3",
				className,
			)}
		>
			<Button
				variant="secondary"
				size="sm"
				disabled={!canPrev}
				onClick={() => onOffsetChange(Math.max(0, offset - pageSize))}
			>
				Prev
			</Button>
			<span className="font-mono-amount text-xs text-muted-foreground">
				{from}–{to} / {total}
			</span>
			<Button
				variant="secondary"
				size="sm"
				disabled={!canNext}
				onClick={() => onOffsetChange(offset + pageSize)}
			>
				Next
			</Button>
		</div>
	);
}
